var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerritory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.05,2H8A6.08,6.08,0,0,0,2,8.09v5.68a6,6,0,0,0,6,6.09h9.05a6,6,0,0,0,6-6.09V8.09A6,6,0,0,0,17.05,2ZM13.79,15H11.3a4.06,4.06,0,0,1,0-8.12h2.49a4.06,4.06,0,1,1,0,8.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.42,19.86h9a6,6,0,0,0,6-6.09V8.09a6,6,0,0,0-6-6.09h-9a6,6,0,0,0-6,6.09v5.68A6,6,0,0,0,34.42,19.86Zm3.25-13h2.49a4.06,4.06,0,1,1,0,8.12H37.67a4.06,4.06,0,0,1,0-8.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05,24.73H8a6.08,6.08,0,0,0-6,6.09v5.69a6.06,6.06,0,0,0,6,6.08h9.05a6.06,6.06,0,0,0,6-6.08V30.82A6,6,0,0,0,17.05,24.73Zm-3.26,13H11.3a4.06,4.06,0,0,1,0-8.12h2.49a4.06,4.06,0,1,1,0,8.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.18,24.73c-6,0-10.81,4.47-10.81,10.05,0,6.94,7.74,13.3,10.13,15a1.17,1.17,0,0,0,1.42,0C42.31,48,50,41.72,50,34.78,50,29.2,45.16,24.73,39.18,24.73Zm0,14.2a4.4,4.4,0,0,1-4.55-4.21,4.57,4.57,0,0,1,9.11,0A4.4,4.4,0,0,1,39.18,38.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritory);
export default __webpack_public_path__ + "static/media/territory.797468113f6db9a6ad126219c73212a5.svg";
export { ForwardRef as ReactComponent };